import { render, staticRenderFns } from "./preguntas.vue?vue&type=template&id=a05b9526&lang=html"
import script from "./preguntas.vue?vue&type=script&lang=js"
export * from "./preguntas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports